/**
 * A single `body-sm` line in `text-tertiary`, centred, with one `ghost` action.
 * No illustrations (components.md §3).
 *
 * The restraint is the point. A user sees an empty Positions table sixty times
 * an hour on their first day, and an illustration is a joke that stops being
 * funny on the second viewing.
 */

import type { ReactNode } from 'react'
import { cx } from '@/lib/cx'
import { Button } from './Button'

export interface EmptyStateProps {
  children: ReactNode
  action?: { label: string; onClick: () => void }
  className?: string
}

export function EmptyState({ children, action, className }: EmptyStateProps) {
  return (
    <div className={cx('flex flex-col items-center justify-center gap-2 py-6', className)}>
      <span className="text-body-sm text-text-tertiary">{children}</span>
      {action ? (
        <Button variant="ghost" size="sm" onClick={action.onClick}>
          {action.label}
        </Button>
      ) : null}
    </div>
  )
}
